import React from 'react';
import  DocumentIcon from '../icons/file-document.svg';
import ExcelIcon from '../icons/file-excel.svg';
import ImageIcon from '../icons/file-image.svg';
import  PdfIcon from '../icons/file-pdf.svg';

const FileIcon = ({extension}) => {
  if (extension === 'pdf') {
    return <PdfIcon />;
  } else if (extension === 'png' || extension === 'jpg') {
    return <ImageIcon />;
  } else if (extension === 'xlsx' || extension === 'xls') {
    return <ExcelIcon />;
  }
  return <DocumentIcon />;
};

export default FileIcon;
